import { globalConstants, surveyQuestionsConstants } from "../../constants";
import { createNewGuid } from "../../../../shared";

const { IS_CHANGES, ADD_QUESTION, GET_QUESTIONS, GET_RECIPIENTS } =
  surveyQuestionsConstants;
const { SUCCESS, FAILURE } = globalConstants;
const initialState = {
  questionsAnswerArray: [],
  recipientsData: [],
  isChanges: false,
  isAddedSurvey: false,
};

//Adding GUID for validation and sorting questions
const addGuid = (questions) => {
  let sortedQuestionArray = questions?.sort(
    (a, b) => a.questionOrder - b.questionOrder
  );
  return sortedQuestionArray.map((ques) => {
    return {
      ...ques,
      guid: createNewGuid(),
    };
  });
};
//Survey question reducer
export const surveyQuestionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_QUESTION + SUCCESS:
      return {
        ...state,
        isAddedSurvey: action.data,
      };
    case GET_QUESTIONS + SUCCESS:
      return {
        ...state,
        //Sorting question array on the basis of question order
        questionsAnswerArray: action?.data?.result?.surveyQuestions?.length
          ? addGuid(action.data.result.surveyQuestions)
          : [],
      };
    case GET_QUESTIONS + FAILURE:
      return {
        ...state,
        questionsAnswerArray: [],
      };
    case GET_RECIPIENTS + SUCCESS:
      return {
        ...state,
        recipientsData: action?.data?.result ? action.data.result : [],
      };
    case GET_RECIPIENTS + FAILURE:
      return {
        ...state,
        recipientsData: [],
      };

    case IS_CHANGES + SUCCESS:
      return {
        ...state,
        isChanges: action.data,
      };
    default:
      return state;
  }
};
